/**
 * useSettingsToggle — shared optimistic toggle helper for the self-contained
 * settings sub-screen sections (Sound / Activities / Tutorials). Mirrors the
 * FeedSettingsSection `persist` pattern: iOS's updateUserSettings never rejects
 * (it rolls back optimistically), so we swallow the web hook's rejection (it
 * already rolls back + logs in onError) to avoid an unhandled promise rejection.
 */
import type { UserSettings } from "@shared_types";
import { useUserSettings } from "@/hooks/useUserSettings";

export function useSettingsToggle() {
  const { settings, updateSettings, isLoading } = useUserSettings();

  const toggle = (key: keyof UserSettings) => {
    if (!settings) return;
    void updateSettings({ [key]: !settings[key] } as Partial<UserSettings>).catch(
      () => {}
    );
  };

  return { settings, isLoading, toggle, updateSettings };
}
